import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelitySummaryTable',
    label: 'Fidelity Summary Table',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
